"use client";

import { createContext } from "react";
import React from "react";

interface FilterablePaginatedSectionState {
  scrollRef?: React.MutableRefObject<HTMLDivElement | null>;
  scrollToTopFunc?: (params: { toTop?: boolean }) => void;
  isScrollingToTop?: boolean;
  setIsScrollingToTop?: React.Dispatch<React.SetStateAction<boolean>>;
  isTransitioning: boolean;
  startTransition: React.TransitionStartFunction;
}

export const FilterablePaginatedSectionContext =
  createContext<FilterablePaginatedSectionState>({
    isTransitioning: false,
    startTransition: () => {},
  });

type Props = React.ComponentProps<
  typeof FilterablePaginatedSectionContext.Provider
>;

export const FilterablePaginatedSectionContextProvider: React.FC<Props> = ({
  value,
  children,
}) => (
  <FilterablePaginatedSectionContext.Provider value={value}>
    {children}
  </FilterablePaginatedSectionContext.Provider>
);
